import { useMemo } from "react";
import { can } from "../utils/permissions";

export const usePermissions = (user) => {
  const permissions = user?.permissions || [];

  const permissionsSet = useMemo(() => new Set(permissions), [permissions]);

  const safeCan = (action, resource, scope) => {
    return can([...permissionsSet], action, resource, scope);
  };
  

  return {
    can: safeCan,
  };
};
